export default "__VITE_ASSET__DsHl8KAu__"